import { connect } from "react-redux";
import { ColorPrediction } from "@learningblocks/simulations/shared-components";
import {
  onColorPredictionSelect,
  onColorPredictionSubmit,
  onColorPredictionReset,
} from "../ColorPrediction/store/actions";

function mapStateToProps(state, ownProps) {
  const entry = state.colorPredictions[ownProps.id];
  if (!entry) {
    // If no matching entry is found, return the original ownProps.
    return ownProps;
  }

  // update options checkboxes checked state based on the state if its same as the state in redux
  const updatedOptions = ownProps.options.map((option, index) => {
    const checkboxes = option.checkboxes.map((box) => {
      if (entry.options[index] === box.value) {
        return { ...box, checked: true };
      } else {
        return { ...box, checked: false };
      }
    });
    const checked = checkboxes.find((checkbox) => checkbox.checked);
    if (checked) {
      option.optionTube.solution = checked.style.backgroundColor;
    }
    return { ...option, checkboxes };
  });

  return {
    ...ownProps,
    options: updatedOptions,
    submitted: entry.submitted || ownProps.submitted,
    feedbackType: entry.feedbackType || ownProps.feedbackType,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onColorSelect: (data) => {
      dispatch(onColorPredictionSelect(data));
    },
    onSubmit: (data) => {
      dispatch(onColorPredictionSubmit(data));
    },
    onReset: (data) => {
      dispatch(onColorPredictionReset(data));
    },
  };
}

export const ColorPredictionRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(ColorPrediction);
